import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { DateTimeService } from '@mews/framework/datetime';
import { convertFormValuesToDateTimes } from '../HourlyServiceDialog/formValues';
import { FormValues } from '../types';

interface GetSuggestedPromotionsOptions {
    values: FormValues;
    timezone: string;
}

const hourOffsets = [-2, -1, 1, 2];

export const getSuggestedPromotions = ({ values, timezone }: GetSuggestedPromotionsOptions) => {
    const dateTimes = convertFormValuesToDateTimes(values, timezone);

    if (dateTimes == null) {
        return [];
    }

    const { startDateTime, endDateTime } = dateTimes;

    const hoursDifference = DateTimeService.diffHours(endDateTime, startDateTime);

    const startOfDay = DateTimeService.startOfDay(startDateTime);
    const endOfDay = DateTimeService.endOfDay(endDateTime);

    const suggestedTimes = pipe(
        hourOffsets,
        array.map((hourOffset) => {
            const numberOfHours = hoursDifference * hourOffset;

            return {
                startDateTime: DateTimeService.addHours(startDateTime, numberOfHours),
                endDateTime: DateTimeService.addHours(endDateTime, numberOfHours),
            };
        }),
        array.filter(
            (suggestion) =>
                DateTimeService.isGreaterOrEqual(suggestion.startDateTime, startOfDay) &&
                DateTimeService.isLessOrEqual(suggestion.endDateTime, endOfDay)
        )
    );

    return suggestedTimes;
};
